<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionStringTypeSelect
      [fixNgSelectBottom]="fractionStringTypeSelect"
      data-cy="fractionStringTypeSelect"
      class="fraction-type-select w-[250px]"
      [items]="fractionStringTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionStringTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionStringTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div
          class="ml-1 truncate"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
          >{{ item.label }}</div
        >
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <form
    [formGroup]="fractionForm"
    class="flex flex-col"
    *ngIf="
      fraction.type === fractionTypeEnum.StringIsEqualTo ||
      fraction.type === fractionTypeEnum.StringStartsWith ||
      fraction.type === fractionTypeEnum.StringEndsWith ||
      fraction.type === fractionTypeEnum.StringContains ||
      fraction.type === fractionTypeEnum.StringIsLike ||
      fraction.type === fractionTypeEnum.StringIsNotEqualTo ||
      fraction.type === fractionTypeEnum.StringDoesNotStartWith ||
      fraction.type === fractionTypeEnum.StringDoesNotEndWith ||
      fraction.type === fractionTypeEnum.StringDoesNotContain ||
      fraction.type === fractionTypeEnum.StringIsNotLike
    "
  >
    <!-- StringIsNull -->
    <!-- StringIsEmpty -->
    <!-- StringIsNotNull -->
    <!-- StringIsNotEmpty -->

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <fieldset [disabled]="isDisabled === true">
        <ng-select
          *ngIf="
            !!suggestModelDimension &&
            (fraction.type === fractionTypeEnum.StringIsEqualTo ||
              fraction.type === fractionTypeEnum.StringIsNotEqualTo)
          "
          #stringValueSelect
          [fixNgSelectBottom]="stringValueSelect"
          data-cy="stringValueSelect"
          class="w-[250px] text-base"
          [ngClass]="{
            'cursor-default': isDisabled === true
          }"
          [items]="items"
          [typeahead]="searchInput$"
          [loading]="loading"
          [clearable]="false"
          [searchable]="true"
          (keyup.esc)="
            $event.stopImmediatePropagation(); stringValueSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); stringValueSelect.blur()
          "
          (change)="stringValueChange($event)"
          (search)="stringValueSearch($event)"
          (open)="onOpenSelect()"
          (close)="onCloseSelect()"
          appendTo="body"
          bindLabel="name"
          bindValue="name"
          formControlName="stringValue"
        >
          <ng-template ng-option-tmp let-item="item">
            <div
              class="truncate"
              [tp]="item.errorMessage"
              [tpIsEnabled]="!!item.errorMessage"
              >{{ item.name }}</div
            >
          </ng-template>
        </ng-select>

        <input
          *ngIf="
            !suggestModelDimension ||
            (fraction.type !== fractionTypeEnum.StringIsEqualTo &&
              fraction.type !== fractionTypeEnum.StringIsNotEqualTo)
          "
          autocomplete="off"
          spellcheck="false"
          data-cy="fractionStringValueInput"
          class="form-input border-s3 focus:border-m600 h-[36px] w-[250px] rounded"
          [ngClass]="{
            'border-r600':
              fractionForm.controls['stringValue'].invalid &&
              fractionForm.controls['stringValue'].touched
          }"
          formControlName="stringValue"
          (blur)="stringValueBlur()"
        />
      </fieldset>
    </div>

    <m-validation
      [control]="fractionForm.controls['stringValue']"
    ></m-validation>
  </form>
</div>
